// index.js — app entry point with MSAL provider
// Place in: reporting-frontend/src/index.js
//
// IMPORTANT: This file must NOT auto-redirect to Entra login.
// Auth routing is handled entirely by App.js which checks for both
// OTP sessions (localStorage otp_token) and Entra accounts before
// deciding what to show. Forcing a redirect here breaks the OTP flow
// for external users who don't have an Entra account.

import React from 'react';
import ReactDOM from 'react-dom/client';
import { EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './msalInstance';
import App from './App';
import './index.css';

// Set active account on any successful Entra login or token acquisition
msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
     event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
     event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload?.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).then((response) => {
  if (response?.account) {
    // Came back from an Entra redirect login — set the account
    msalInstance.setActiveAccount(response.account);
  } else {
    // Restore Entra account from cache if one exists
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
    // No Entra account — do NOT redirect. App.js will check for an OTP
    // session (localStorage otp_token) and show LoginPage if neither exists.
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
});
